const ClientTypes = Object.freeze({
  BUSINESS: 1,
  PERSONAL: 2,
});

export default ClientTypes;
